export default __webpack_public_path__ + "static/media/step1.9043bc91.svg";